(function () {
    'use strict';

    angular
        .module('app.productBrand')
        .run(appRun);

    appRun.$inject = ['routerHelper'];

    function appRun(routerHelper) {
        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [{
                state: 'productBrand',
                config: {
                    url: '/productbrand',
                    title: 'Markalar',
                    abstract: true,
                    templateUrl: 'app/productBrands/productBrand.html'
                }
            },
            {
                state: 'productBrand.list',
                config: {
                    templateUrl: 'app/productBrands/productBrand.list.html',
                    controller: 'ProductBrandListController',
                    controllerAs: 'vm',
                    url: '/list',
                    title: 'Marka Listesi',
                    settings: {
                        nav: 4,
                        name: 'productBrand.list',
                        topName: 'products',
                        content: 'Marka Listesi',
                        resource: 'menu.productBrand.list'
                    }
                }
            }
        ];
    }
})();